export const ROLE_ACCESS_COMPARISON = [
    {
        area: "Usuarios",
        admin: "Crea y edita administradores o colaboradores. No puede crear ni modificar propietarios.",
        staff: "No administra usuarios ni roles.",
    },
    {
        area: "Organización",
        admin: "Puede editar superficies operativas según el tipo de organización.",
        staff: "Solo consulta información necesaria para su trabajo.",
    },
    {
        area: "Servicios y calendario",
        admin: "Proveedor: gestiona servicios y calendarios. Concierge: consulta catálogo y disponibilidad.",
        staff: "Proveedor: lectura operativa. Concierge: catálogo y disponibilidad para reservas.",
    },
    {
        area: "Clientes e itinerarios",
        admin: "Concierge: gestiona clientes e itinerarios.",
        staff: "Concierge: trabaja clientes e itinerarios, sin gestión de miembros.",
    },
    {
        area: "Plataforma",
        admin: "Sin acceso a configuración global, ciclo de vida de organizaciones ni super admins.",
        staff: "Sin acceso a configuración global, ciclo de vida de organizaciones ni super admins.",
    },
];
